import "./Filter.scss";
import block from "bem-cn";
import Tags from "@yaireo/tagify/dist/react.tagify"; // React-wrapper file
import "@yaireo/tagify/dist/tagify.css"; // Tagify CSS
import BusyComboBox from "../BusyComboBox/BusyComboBox";
import { ChangeEventData } from "@yaireo/tagify";
import { useAppDispatch } from "../../app/hooks";
import { changeTagList } from "./FilterSlice";
import { busyItems, busyItemsAll } from "./config";
import BusyComboBox2 from "../BusyComboBox2/BusyComboBox2";
import { busyItems2 } from "../BusyComboBox2/config";
import React, { Children } from "react";

const b = block("Filter");

type Props = {
  tags: tagList;
  whitelist?: string[];
};

const Filter = ({ tags, whitelist = [] }: Props) => {
  const dispatch = useAppDispatch();

  const handleOnChangeTags = (e: CustomEvent<ChangeEventData>) => {
    if (e.detail.value.length) {
      const tl = JSON.parse(e.detail.value);
      dispatch(changeTagList(tl));
    } else dispatch(changeTagList([]));
  };

  return (
    <ul className={b()}>
      <li className={b("item-input", { minWidth: true })}>
        <Tags
          value={tags}
          placeholder={"Поиск по стеку"}
          onChange={handleOnChangeTags}
          whitelist={whitelist}
        />
      </li>
      <li className={b("item-select", { rightAlignment: false })}>
        {/* <BusyComboBox itemAll={busyItemsAll} items={busyItems} /> */}
        <BusyComboBox2 items={busyItems2} />
      </li>
    </ul>
  );
};

export default Filter;
